
import { VueFn } from '@/common/VueFn'
import { reactive, toRefs, watchEffect } from 'vue'
export default {
  components: {},
  props: {
    cookieOption: { default: null as any, required: true },
  },
  setup(props, { emit }) {
    const state = reactive({
      name: 'WimCookie',
      disabled: false,
      showOptions: true,
      lang: window['$BenQuery'],
    })

    watchEffect(() => {
      state.showOptions = props.cookieOption === null
    })

    const fn = {
      rejectClick() {
        emit('rejectClick')
      },
      acceptClick() {
        emit('acceptClick')
      },
    }

    return { ...VueFn, ...toRefs(state), state, ...fn }
  },
}
